﻿import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';

import Button from 'components/Button';
import { Checkbox } from 'components/Form';

import theme from "./TreatmentAreasForm.module.sass";

const TreatmentAreasForm = ({ defaultValues, onSubmit }) => {
  const { register, watch, handleSubmit } = useForm({
    defaultValues,
  });
  const treatmentAreas = watch(['face', 'back', 'chest']);
  const hasSelected = Object.values(treatmentAreas).some((area) => !!area);
  return (
    <form>
      <h4 className={theme.Title}>Select Treatment Type</h4>
      <div className={theme.Area}>
        <Checkbox
          id="face"
          size="small"
          value="face"
          {...register("face")}
        />
        <label htmlFor="face">Face</label>
      </div>
      <div className={theme.Area}>
        <Checkbox
          id="back"
          size="small"
          value="back"
          {...register("back")}
        />
        <label htmlFor="back">Back</label>
      </div>
      <div className={theme.Area}>
        <Checkbox
          id="chest"
          size="small"
          value="chest"
          {...register("chest")}
        />
        <label htmlFor="chest">Chest</label>
      </div>
      <footer className={theme.Actions}>
        <div className={theme.MainActions}>
          <Button
            classes={[theme.Action]}
            size="big"
            color="secondary"
            onClick={handleSubmit((values) => {
              onSubmit({
                ...values,
                submitAction: 'previous',
              });
            })}
          >
            Previous
          </Button>
          <Button
            classes={[theme.Action]}
            size="big"
            disabled={!hasSelected}
            onClick={handleSubmit((values) => {
              onSubmit({
                ...values,
                submitAction: 'next',
              });
            })}
          >
            Next
          </Button>
        </div>
      </footer>
    </form>
  );
};

TreatmentAreasForm.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
};

export default TreatmentAreasForm;
